import { registerEnumType } from 'type-graphql'

// The status the mobile builds that predate conversations read. A ticket has no Cancelled state, so
// a cancelled conversation reads as Closed (toSupportTicket.ts).
export enum SupportTicketStatusEnum {
  New = 'New',
  Pending = 'Pending',
  Open = 'Open',
  Closed = 'Closed',
}

registerEnumType(SupportTicketStatusEnum, {
  name: 'SupportTicketStatusEnum',
  description: 'Lifecycle status of a support ticket, as the older mobile builds read a conversation.',
})
